import { CANVAS_CUSTOM_PROPERTIES_FIELD } from "../constants/canvasConstants";
import { Canvas } from "../types/canvasTypes";

export function setCustomProperties(canvas: Canvas, obj: Canvas[typeof CANVAS_CUSTOM_PROPERTIES_FIELD]) {
  canvas[CANVAS_CUSTOM_PROPERTIES_FIELD] = obj;
}

export function isHistoryProcessing(canvas: Canvas) {
  return getCustomProperties(canvas)?.isHistoryProcessing ?? false;
}

function getCustomProperties(canvas: Canvas) {
  return canvas[CANVAS_CUSTOM_PROPERTIES_FIELD];
}
